// extracted by mini-css-extract-plugin
module.exports = {"footer":"_2pxSTuVKVa"};
    if(module.hot) {
      // 1597843270325
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  